import { render, staticRenderFns } from "./DownloadPluginIcon.vue?vue&type=template&id=5d0c11e4&scoped=true&"
import script from "./DownloadPluginIcon.vue?vue&type=script&lang=js&"
export * from "./DownloadPluginIcon.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPluginIcon.vue?vue&type=style&index=0&id=5d0c11e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c11e4",
  null
  
)

export default component.exports